import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import UnreadCountBadge from "./UnreadCountBadge";

function Panel(props) {
  const { children, value, index } = props;
  const show = value === index;
  return (
    <div
      role="tabpanel"
      hidden={!show}
      id={`tab-panel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {show && (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            width: "100%",
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}

Panel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function UnreadToggle({
  value,
  onChange,
  projectUnreadCount = 0,
  jobUnreadCount = 0,
}) {
  return (
    <Tabs
      value={value === "projects" ? 0 : 1}
      onChange={(_e, v) => onChange(v === 0 ? "projects" : "jobs")}
      sx={{
        border: "1px solid #D1D5DB",
        borderRadius: "9999px",
        backgroundColor: "#E5E7EB",
        minHeight: "auto",
        "& .MuiTabs-indicator": { display: "none" },

        "& .MuiTab-root": {
          textTransform: "none",
          fontWeight: 700,
          fontSize: "0.75rem",
          color: "#6B7280",
          minHeight: "auto",
          minWidth: 0,
          px: 5,
          py: 1.2,
          borderRadius: "9999px",
          transition: "all 0.3s",
          "&:hover": { opacity: 0.9 },
        },

        "& .MuiTab-root.Mui-selected": {
          color: "#fff",
        },

        "& .MuiTab-root:nth-of-type(1).Mui-selected": {
          background: "linear-gradient(to right, #c084fc, #6366f1)",
        },
        "& .MuiTab-root:nth-of-type(2).Mui-selected": {
          background: "linear-gradient(to right, #2563eb, #7dd3fc)",
        },
      }}
    >
      <Tab
        label={
          <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
            <span>未読プロジェクト</span>
            {projectUnreadCount > 0 && (
              <UnreadCountBadge inline count={projectUnreadCount}>
                <span />
              </UnreadCountBadge>
            )}
          </Box>
        }
      />
      <Tab
        label={
          <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
            <span>未読求人</span>
            {jobUnreadCount > 0 && (
              <UnreadCountBadge inline count={jobUnreadCount}>
                <span />
              </UnreadCountBadge>
            )}
          </Box>
        }
      />
    </Tabs>
  );
}

UnreadToggle.propTypes = {
  value: PropTypes.oneOf(["projects", "jobs"]).isRequired,
  onChange: PropTypes.func.isRequired,
  projectUnreadCount: PropTypes.number,
  jobUnreadCount: PropTypes.number,
};